import { useLocation } from 'react-router-dom';
import { FeatureFlagVariationValue, useFeatureFlag } from '@moda/portal-stanchions';

const isTreatmentStringArray = (treatment: FeatureFlagVariationValue): treatment is string[] =>
  Array.isArray(treatment) && treatment.every(item => typeof item === 'string');

export const useShowSaleOnPLP = () => {
  const { pathname } = useLocation();

  const paths = useFeatureFlag('show-sale-on-plps', [
    { default: [] },
    { getFromTreatment: treatment => (isTreatmentStringArray(treatment) ? treatment : []) }
  ]);

  return paths.some(path => new RegExp(`^${path}$`).test(pathname));
};
